export const tableColumns = [
  "Voucher Code",
  "Old PNR Number",
  "Customer Mobile",
  "Voucher Value",
  "Refund Amount",
  "Redeemed Amount",
  "Validity",
  "Redemption Date",
  "Action",
];
